export const INIT_ACCOUNT = {
  id: "ALL",
  name: "すべて",
  department: "すべて",
} as const;

export const INIT_DEPARTMENT = "すべて";

export const KEEP_GLOBAL_DEPARTMENT_KEY = "keep-global-department";
export const KEEP_GLOBAL_ACCOUNT_ID_KEY = "keep-global-account-id";
export const KEEP_GLOBAL_FILTER_PENDING_SYNC_KEY = "keep-global-filter-pending-sync";
